import React, { Component, type ErrorInfo, type ReactNode } from "react";

type Props = { children: ReactNode };

type State = { error: Error | null };

/**
 * Surfaces React render errors instead of a silent white screen (production hides overlay).
 */
export class RootErrorBoundary extends Component<Props, State> {
	state: State = { error: null };

	static getDerivedStateFromError(error: Error): State {
		return { error };
	}

	componentDidCatch(error: Error, info: ErrorInfo) {
		console.error("Root render error:", error, info.componentStack);
	}

	render() {
		if (this.state.error) {
			return (
				<div
					style={{
						minHeight: "100dvh",
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						justifyContent: "center",
						padding: 24,
						fontFamily: "system-ui, sans-serif",
						background: "#FAF9F6",
						color: "#1a1a1a",
						boxSizing: "border-box",
					}}
				>
					<p style={{ fontWeight: 600, marginBottom: 8 }}>Something went wrong</p>
					<pre
						style={{
							maxWidth: "90vw",
							overflow: "auto",
							fontSize: 12,
							opacity: 0.85,
							whiteSpace: "pre-wrap",
							wordBreak: "break-word",
						}}
					>
						{this.state.error.message}
					</pre>
				</div>
			);
		}
		return this.props.children;
	}
}
